import usePageLoad from './usePageLoad';

export {usePageLoad};
